import React from 'react';
import { closeModalData } from '../../Demo/DemoPlayApp';

interface CancelPopupProps {
  onClose: () => void; 
  closeModal:closeModalData,
}

const CancelPop: React.FC<CancelPopupProps> = ({ onClose ,closeModal}) => {
  const getText=closeModal.test
  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
      <div className="relative  shadow-lg w-[800px]  h-[500px] flex flex-col items-center justify-center">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-90"
          style={{ backgroundImage: `url(${'/assets/winnersBg.png'})` }}
        ></div>
        <img
          src={'/assets/lottoTicket.png'}
          alt="Lotto Ticket"
          className="relative z-10 md:w-[218px] lg:w-[218px] w-[150px] h-auto mt-12 md:mt-28 lg:mt-28"
        />
        {
        getText &&   getText.length >35 ?  <p className='z-10 py-8 font-bold max-w-[400px] text-center text-white text-[12px] md:text-[14px] lg:text-[18px]'>{getText}</p> :  <p className='z-10 py-8 font-bold max-w-[400px] text-center text-white text-[16px] md:text-[20px] lg:text-[22px]'>{getText}</p> 
        }
        <button
          onClick={onClose}
          className={`relative z-10 w-40 h-16 text-white flex justify-center items-center  ${getText ? 'lg:mt-6 md:mt-8 ' :'mt-36'}  flex-end `}
          style={{
            backgroundImage: `url(${'/assets/blueButton.png'})`,  
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        >
         {closeModal.btnText ? closeModal.btnText : "Go Back"}
        </button>
      </div>
    </div>
  );
};

export default CancelPop;